<template>
    <loading v-if="loading"></loading>
    <div v-else-if="examplePostAdded">
        <p class="font-weight-bold">Congratulations, your tab(s) are now fully operational! 🎉</p>
        <p>We've taken the liberty of adding an example post to showcase their stunning potential.</p>
        <a class="btn btn-primary" :href="redirect">Check it out</a>
    </div>
    <div v-else class="feature-setup">
        <b-form @submit.prevent="handleSubmit">
            <b-alert variant="danger" v-if="selectOptionError" show>Please select an option to continue.</b-alert>

            <div class="row">
                <div class="col-12 col-md-6 col-lg-4 mb-3" v-for="option in featureOptions" :key="option.value">
                    <b-card
                        class="h-100 hover-card"
                        :border-variant="selectedFeatures.includes(option.value) ? 'primary' : 'outline'"
                        @click="toggleFeature(option.value, option.enabled, option.permanent)"
                        :style="{ cursor: option.permanent ? 'default' : 'pointer', opacity: option.enabled ? 1 : 0.5 }"
                        no-body
                    >
                        <div class="card-body d-flex" v-b-tooltip :title="option.tooltip">
                            <div class="flex-shrink-0" style="width: 48px;">
                                <b-icon :icon="option.icon" :variant="option.color" scale="1.5"></b-icon>
                            </div>
                            <div class="flex-grow-1">
                                <b-card-title class="d-flex align-items-center">
                                    {{ option.text }}
                                    <i v-if="selectedFeatures.includes(option.value)" class="bi bi-check2-circle ml-2"></i>
                                </b-card-title>
                                <b-card-text>{{ option.description }}</b-card-text>
                            </div>
                        </div>
                    </b-card>
                </div>
            </div>

            <div class="text-center">
                <b-button type="submit" variant="primary" class="mt-3 py-2 px-5">Save <b-icon icon="arrow-right"></b-icon> </b-button>
            </div>
        </b-form>
    </div>
</template>

<script>
import Loading
    from "./Loading";
import NotificationPop
    from "../mixins/NotificationPop";

export default {
    components: {
        Loading
    },
    mixins: [NotificationPop],
    data() {
        return {
            selectOptionError: false,
            selectedFeatures: [],
            loading: true, // Initially true to simulate loading state
            featureOptions: [
                // Duplicate with Onboarding
                {
                    text: 'Plan Your Roadmap',
                    icon: 'map',
                    value: 'roadmap',
                    description: 'Outline and share your product\'s development timeline.',
                    enabled: true,
                    color: 'info'  // Blue
                },
                {
                    text: 'Collect User Feedback',
                    icon: 'heart',
                    value: 'feedbackBoard',
                    description: 'Collect and review user suggestions.',
                    enabled: true,
                    color: 'danger'  // Red
                },
                {
                    text: 'Announce Updates with a Changelog',
                    icon: 'check-circle',
                    value: 'changelog',
                    description: 'Keep a record of all updates and announce new features.',
                    enabled: true,
                    color: 'success'  // Green
                },
                {
                    text: 'Create a Knowledge Base',
                    icon: 'book',
                    value: 'knowledgebase',
                    description: 'Create a library of articles and help guides.',
                    enabled: true,
                    color: 'warning'  // Yellow/Orange
                },
                {
                    text: 'General Kanban Board',
                    icon: 'layout-three-columns',
                    value: 'scrumBoard',
                    description: 'Visualize workflow and track tasks from start to finish with customizable stages.',
                    enabled: true,
                    // tooltip: 'Will be hidden on default for your users.',
                    color: 'grey'  // Primary blue
                },
                {
                    text: 'Custom Board',
                    icon: 'house-gear',
                    value: 'custom',
                    description: 'Organize and display content dynamically, either as text or through a custom query.',
                    enabled: true,
                    // tooltip: 'Will be hidden on default for your users.',
                    color: 'grey'  // Primary blue
                }

                // { text: 'Support Forums', icon: 'chat-left-quote', value: 'supportForums', description: 'Prepare a space for users to discuss and help each other.', enabled: false, tooltip: 'Coming soon' },
                // { text: 'Challenges', icon: 'trophy', value: 'challenges', description: 'Post questions or topics for users to solve.', enabled: false, tooltip: 'Coming soon' }
                // { text: 'Todo List', icon: 'check2-square', value: 'todoList', description: 'Organize tasks and monitor their status.', enabled: true },
            ],
            redirect: '/',
            examplePostAdded: false,
        };
    },
    mounted() {
        // Simulate loading state as if fetching feature options from an API
        setTimeout(() => {
            this.loading = false; // Assume data is loaded and update loading state
        }, 500);
    },
    methods: {
        toggleFeature(value, enabled, permanent) {
            if (!enabled || permanent) {
                return; // Do not allow toggling if the feature is permanent
            }
            const index = this.selectedFeatures.indexOf(value);
            if (index === -1) {
                this.selectedFeatures.push(value);
            } else {
                this.selectedFeatures.splice(index, 1);
            }
        },
        handleSubmit() {
            this.loading = true;

            const featuresData = {
                templates: this.selectedFeatures
            };

            if (this.selectedFeatures.length === 0) {
                this.selectOptionError = true
                this.loading = false;
                return;
            }

            this.$http.post('/http_api/boards_template/create', featuresData)
                .then(response => {
                    if (response.status !== 200) {
                        throw new Error('Unexpected response status');
                    }

                    const redirectUrl = response.data.redirect ?? this.redirect; // Use backend-provided URL if available

                    this.popNotification('Templates setup successfully. Redirecting now.', 'success');

                    window.location.href = redirectUrl; // Navigate based on the response from the backend

                    // Scroll to the top of the page
                    window.scrollTo({
                        top: 0,
                        behavior: 'smooth'
                    });

                })
                .catch(error => {
                    console.error('Error setting up features:', error);
                    this.popNotification('Failed to setup features. Please try again.', 'danger');
                    this.loading = false;
                });

        }
    }
};
</script>
